import { useTranslation } from 'react-i18next';
import { Button } from '@shared/ui';
import { LOCALES, type Locale } from '@shared/i18n';
import { useSessionStore } from '@entities/session';
import { useLogout } from '@features/auth';
import { initials } from '@shared/lib/format';

const LOCALE_LABEL: Record<Locale, string> = { ru: 'RU', en: 'EN', uz: 'UZ' };

export function Topbar() {
  const { t, i18n } = useTranslation();
  const identity = useSessionStore((s) => s.identity);
  const logout = useLogout();

  const current = (i18n.language?.startsWith('ru')
    ? 'ru'
    : i18n.language?.startsWith('uz')
      ? 'uz'
      : 'en') as Locale;

  return (
    <header className="flex h-14 items-center justify-end gap-3 border-b bg-card px-4">
      <select
        value={current}
        onChange={(e) => {
          void i18n.changeLanguage(e.target.value);
        }}
        className="h-8 rounded-md border bg-background px-2 text-xs"
        aria-label="Language"
      >
        {LOCALES.map((l) => (
          <option key={l} value={l}>
            {LOCALE_LABEL[l]}
          </option>
        ))}
      </select>
      <div className="flex items-center gap-2 text-sm">
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary/10 text-xs font-medium text-primary">
          {initials(identity?.displayName ?? identity?.email ?? '?')}
        </div>
        <span className="text-muted-foreground">{identity?.email ?? '—'}</span>
      </div>
      <Button variant="outline" size="sm" onClick={() => logout.mutate()}>
        {t('nav.logout')}
      </Button>
    </header>
  );
}
